// import { useEffect } from "react";
// import socket from "./Socket";

// export function useConfigSocket(onGlobal, onUser) {
//   useEffect(() => {
//     socket.on("siteConfigUpdated", onGlobal);
//     socket.on("userConfigUpdated", onUser);

//     socket.emit("requestSiteConfig");
//     socket.emit("requestUserConfig");

//     return () => {
//       socket.off("siteConfigUpdated", onGlobal);
//       socket.off("userConfigUpdated", onUser);
//     };
//   }, [onGlobal, onUser]);
// }

import { useEffect } from "react";
import socket from "./Socket";
import C from "./Constant";
import { getUID, encode, decode } from "./Helper"; 
import Storage from "./Storage";

export function useConfigSocket(onGlobal, onUser, UserSetdata) {
  useEffect(() => {
    console.log("🔌 useConfigSocket - setting up socket listeners");

    // --- Handlers ---
    const handleUserInfo = (data) => {
      const decodedData = decode(data);
      console.log("👤 useConfigSocket - decoded USER_INFO:", decodedData);

      // Store parent_id in localStorage for deposit modal access
      if (decodedData?.parent_id !== undefined) {
        Storage.setKey("parent_id", String(decodedData.parent_id));
      }

      // if parent passed a handler, call it
      if (UserSetdata) {
        UserSetdata(decodedData);
      }

      // you can also handle "status" logic here if needed
      if (decodedData?.status) {
        console.log("✅ user status is true");
      }
    };

    socket.on("siteConfigUpdated", (data) => { console.log("🌍 useConfigSocket - received siteConfigUpdated:", data); onGlobal(data); }); 
    socket.on("userConfigUpdated", (data) => { console.log("👤 useConfigSocket - received userConfigUpdated:", data); onUser(data); });

    // --- Attach listeners ---
    socket.on(C.USER_INFO, handleUserInfo);


    // --- Emit initial requests ---
    socket.emit("requestSiteConfig");
    const uid = getUID();
    if (uid) {
      socket.emit("identify", uid);
    }
    socket.emit("requestUserConfig");
    socket.emit(
      C.USER_INFO,
      encode({
        id: getUID(),
        coin: Storage.getKey("coin") || "",
        rate: null,
        game: "all",
        first: true,
      })
    );



    // --- Cleanup ---
    return () => {
      console.log("🔌 useConfigSocket - cleaning up socket listeners");
      socket.off(C.USER_INFO, handleUserInfo);
      socket.off("siteConfigUpdated", onGlobal);
      socket.off("userConfigUpdated", onUser);
    };
  }, [onGlobal, onUser, UserSetdata]);
}